import { DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION /*, FLAGSMITH_FEATURES */ } from '../constants'
// import useFlagsmithFeature from './useFlagsmithFeature'

const useFoodDiaryFeature = ({ study = {}, userId }) => {
  const { config /* id: studyID */ } = study
  const instrumentArchitectureVersion =
    config?.instrument_architecture_version || DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION

  // const flagsmithFeatures = useFlagsmithFeature({
  //   /**
  //    * For the featureFlags key, we put in a object for what the default value of
  //    * the feature flag(s) should be in case there is an error with the Flagsmith API.
  //    */
  //   featureFlags: { [FLAGSMITH_FEATURES.foodDiary]: { enabled: true } },
  //   userId,
  //   studyId: studyID,
  // })

  // We will show Food Diary UI only when ALL of these conditions are met
  // - `instrument_architecture_version` > 1
  // - Study config contains `food_diary` field with value equals to `{}`
  const hasFoodDiary = !!config?.food_diary && instrumentArchitectureVersion > DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION // && flagsmithFeatures[FLAGSMITH_FEATURES.foodDiary]?.enabled

  return {
    hasFoodDiary,
  }
}

export default useFoodDiaryFeature
